import React from 'react';
import Placeholder from './Placholder';
import { models } from 'powerbi-client';
import { Grid } from '@mui/material';
import { PowerBIEmbed } from 'powerbi-client-react';
import uuid from '../../Utils/uuid';
import { PrimaryButton } from '../Common';
import Greenchill from './Greenchill';
import EpaSection608 from './EpaSection608/EpaSection608';
import ChronicallyLeaking608 from './ChronicallyLeaking608';
import ContactEPA from '../../pages/Analytics/ContactEPA';
import CARBR3XML from '../../pages/Analytics/CARBR3XML';
import InstalledInventoryEmissionsExposure from '../../pages/Analytics/InstalledInventoryEmissionsExposure';
import NYDECExport from './NYDECExport';
import ServiceBasedScope1 from '../../pages/Analytics/ServiceBasedScope1';
import LeakRateCompliance from '../../pages/Analytics/LeakRateCompliance';

const AnalyticReportContainer = ({
    selectedReport,
    powerBiReports
}) => {
    // AB#17082 AC1: the Leak Rate Report's "Period of Time" slicer ships with a static
    // saved range that goes stale between publishes; on load, reset it to the trailing
    // 365 days ending today so the default is computed at open time.
    const formatSlicerDate = (date) => {
        const pad = (n) => String(n).padStart(2, '0');
        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T00:00:00`;
    };

    const setDefaultPeriodOfTime = async (report) => {
        try {
            const pages = await report.getPages();
            const page = pages.find(p => p.isActive) || pages[0];
            const visuals = await page.getVisuals();
            const slicers = visuals.filter(v => v.type === 'slicer');
            const endDate = new Date();
            const startDate = new Date();
            startDate.setDate(startDate.getDate() - 365);
            for (const slicer of slicers) {
                const state = await slicer.getSlicerState();
                const target = state && state.targets && state.targets[0];
                if (target && target.table === 'DateTable' && target.column === 'Date') {
                    await slicer.setSlicerState({
                        filters: [{
                            $schema: 'http://powerbi.com/product/schema#advanced',
                            target,
                            filterType: models.FilterType.Advanced,
                            logicalOperator: 'And',
                            conditions: [
                                { operator: 'GreaterThanOrEqual', value: formatSlicerDate(startDate) },
                                { operator: 'LessThanOrEqual', value: formatSlicerDate(endDate) }
                            ]
                        }]
                    });
                }
            }
        } catch (error) {
            console.log('setDefaultPeriodOfTime:', error);
        }
    };

    const renderPowerbi = (url) => {
        const reportData = powerBiReports.find(r => r.embedUrl === url);

        return <>
        <Grid container>
            <Grid item xs={12} md={12} lg={12}>
                {reportData && !reportData.token && (
                <Grid item xs={12} md={12} lg={12}>
                    This report could not be loaded. Please try again later.
                </Grid>
                )}
                {reportData && reportData.token && (
                <Grid item xs={12} md={12} lg={12}>
                    <PowerBIEmbed
                        key={uuid.getUuid()}
                        cssClassName="powerBIPanel"
                        embedConfig={{
                            type: 'report',
                            id: reportData.id,
                            embedUrl: reportData.embedUrl,
                            accessToken: reportData.token,
                            tokenType: models.TokenType.Embed,
                            settings: {
                                background: models.BackgroundType.Transparent,
                                panes: {
                                    filters: {
                                        visible: false
                                    },
                                    pageNavigation: {
                                        visible: true,
                                        position: 1
                                    }
                                },
                            }
                        }}
                        eventHandlers={
                            new Map([
                                ['loaded', function (event, embeddedReport) {
                                    console.log('Report loaded');
                                    if (reportData.name === 'DWH_Leak Rate Report' && embeddedReport) {
                                        setDefaultPeriodOfTime(embeddedReport);
                                    }
                                }],
                                ['rendered', function () { console.log('Report rendered'); }],
                                ['error', function (event) { console.log(event.detail); }]
                            ])
                        }
                    />
                </Grid>
              )}
            </Grid>
        </Grid>
    </>;
      };

    const renderReport = (id) => {
      const reportList = {
        16: Greenchill,
        20: ContactEPA,
        27: EpaSection608,
        31: ChronicallyLeaking608,
        45: CARBR3XML,
        51: NYDECExport,
        52: InstalledInventoryEmissionsExposure,
        53: ServiceBasedScope1,
        51: NYDECExport,
        // 100: Leak Rate Compliance (User Story 14579).
        // Requires a row in dbo.Reports with Id = 100 under the Sustainability section.
        // (Id 52 was already in use on beta — "Installed Inventory - Emissions Exposure".)
        100: LeakRateCompliance
      };
      if (!reportList[id]) return null;
      const ReportComponent = reportList[id]; 
      return <ReportComponent />;
    };

    return (
        <div >
            {selectedReport.powerBiLink ? renderPowerbi(selectedReport.powerBiLink) : renderReport(selectedReport.id)}
        </div>
    );
};

export default AnalyticReportContainer;
